import React from "react";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/News/VolantinoGare.png"
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import SpaceL from "../../commons/SpaceL";
import TitoloSezioni from "../../commons/TitoloSezioni";

function GareSociali2026 () {
    const gareMattino = [
        { label: "25 DO", file: "classifica_mattino_25DO.pdf" },
        { label: "25 SL", file: "classifica_mattino_25SL.pdf" },
        { label: "50 DO", file: "classifica_mattino_50DO.pdf" },
        { label: "50 SL", file: "classifica_mattino_50SL.pdf" },
        { label: "25 RA", file: "classifica_mattino_25RA.pdf" },
        { label: "25 FA", file: "classifica_mattino_25FA.pdf" },
        { label: "100 MI", file: "classifica_mattino_100MI.pdf" },
    ];

    const garePomeriggio = [
        { label: "25 DO", file: "classifica_pomeriggio_25DO.pdf" },
        { label: "25 SL", file: "classifica_pomeriggio_25SL.pdf" },
        { label: "50 DO", file: "classifica_pomeriggio_50DO.pdf" },
        { label: "50 SL", file: "classifica_pomeriggio_50SL.pdf" },
        { label: "25 RA", file: "classifica_pomeriggio_25RA.pdf" },
        { label: "25 FA", file: "classifica_pomeriggio_25FA.pdf" },
        { label: "100 MI", file: "classifica_pomeriggio_100MI.pdf" },
    ];

    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />

            <TitoloSezioni title={"Gare sociali di nuoto 2026"} />
            <SpaceL />


            {/* --- SEZIONE CLASSIFICHE --- */}
            <div className="mb-5" style={{ background: "#f8f9fa", padding: "25px", borderRadius: "10px", border: "1px solid #eee" }}>
                <h4 style={{ fontWeight: "800", color: "#d9534f", letterSpacing: "1px", marginBottom: "25px" }}>CLASSIFICHE FINALI</h4>

                {/* CLASSIFICHE MATTINO */}
                <div className="mb-4">
                    <h5 style={{ fontWeight: "700", fontSize: "16px", textTransform: "uppercase", color: "#555", marginBottom: "10px" }}>Mattino</h5>
                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", fontSize: "16px" }}>
                        {gareMattino.map((gara, idx) => (
                            <React.Fragment key={`mat-${gara.label}`}>
                                <a
                                    style={{ color: "black", textDecoration: "underline", fontWeight: "600" }}
                                    href={`/documents/Gare26/${gara.file}`}
                                    download={gara.file}
                                >
                                    {gara.label}
                                </a>
                                {idx < gareMattino.length - 1 && <span style={{ color: "#ccc" }}>|</span>}
                            </React.Fragment>
                        ))}
                    </div>
                </div>

                <div style={{ width: "30%", height: "1px", background: "#eee", margin: "20px auto" }}></div>

                {/* CLASSIFICHE POMERIGGIO */}
                <div>
                    <h5 style={{ fontWeight: "700", fontSize: "16px", textTransform: "uppercase", color: "#555", marginBottom: "10px" }}>Pomeriggio</h5>
                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", fontSize: "16px" }}>
                        {garePomeriggio.map((gara, idx) => (
                            <React.Fragment key={`pom-${gara.label}`}>
                                <a
                                    style={{ color: "black", textDecoration: "underline", fontWeight: "600" }}
                                    href={`/documents/Gare26/${gara.file}`}
                                    download={gara.file}
                                >
                                    {gara.label}
                                </a>
                                {idx < garePomeriggio.length - 1 && <span style={{ color: "#ccc" }}>|</span>}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>


            {/* --- MATTINO (Programmi e Start List) --- */}
            <div className="mb-5">
                <h4 style={{ fontWeight: "800", color: "#d9534f", letterSpacing: "1px", marginBottom: "25px" }}>Programma</h4>
                <h5 style={{ fontWeight: "700", fontSize: "16px", textTransform: "uppercase", color: "#555", marginBottom: "10px" }}>Mattino</h5>
                <div style={{ fontSize: "18px", marginTop: "10px" }}>

                    <a style={{color: "black", textDecoration: "underline", fontWeight: "500"}} href="/documents/Gare26/programma_MATTINO.pdf" download="programma_MATTINO.pdf">
                        Programma
                    </a>
                    <span style={{color: "#ddd", margin: "0 15px"}}>|</span>

                    <a style={{color: "black", textDecoration: "underline", fontWeight: "500"}} href="/documents/Gare26/startlist_MATTINO.pdf" download="startlist_MATTINO.pdf">
                        Start List
                    </a>
                </div>
            </div>

            {/* --- POMERIGGIO --- */}
            <div className="mb-5">
                <h5 style={{ fontWeight: "700", fontSize: "16px", textTransform: "uppercase", color: "#555", marginBottom: "10px" }}>Pomeriggio</h5>
                <div style={{ fontSize: "18px", marginTop: "10px" }}>

                    <a style={{color: "black", textDecoration: "underline", fontWeight: "500"}} href="/documents/Gare26/programma_POMERIGGIO.pdf" download="programma_POMERIGGIO.pdf">
                        Programma
                    </a>
                    <span style={{color: "#ddd", margin: "0 15px"}}>|</span>

                    <a style={{color: "black", textDecoration: "underline", fontWeight: "500"}} href="/documents/Gare26/startlist_POMERIGGIO.pdf" download="startlist_POMERIGGIO.pdf">
                        Start List
                    </a>
                </div>
            </div>

            <SpaceL />

            <p className="text-center" style={{ fontSize: "15px", color: "#666", fontStyle: "italic" }}>
                Si avvisano i gentili clienti che in occasione delle gare sociali
                <br/>
                l'intero centro rimarrà <strong>chiuso</strong>.
            </p>

            <SpaceL />

            <div className="container-foto-news m-auto d-none d-sm-flex" style={{flexDirection: "column", width: "40%"}}>
                <img src={locandina} style={{width: "100%", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"}} alt="Locandina"/>
                <Space />
            </div>

            <div className="container-foto-news m-auto d-sm-none" style={{display: "flex", flexDirection: "column", width: "80%"}}>
                <img src={locandina} style={{width: "100%", borderRadius: "10px"}} alt="Locandina"/>
                <SpaceL />
            </div>

            <Space />
        </div>
    )
}

export default GareSociali2026;